export default __webpack_public_path__ + "static/IMG_4997-4a05172dbe0854351b8e72b23d2dd20b.jpg";